import { render, staticRenderFns } from "./YoneticiCRUD.vue?vue&type=template&id=48f17a68"
import script from "./YoneticiCRUD.vue?vue&type=script&lang=js"
export * from "./YoneticiCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports